import { ElementInfo } from "../Models/ElementInfoModel";
import * as OBC from "@thatopen/components";
import { ModelInfo } from "../Models/ModelInfo";
export const Hide = (ids: ElementInfo[], components: OBC.Components, modelIds: ModelInfo[]) => {
    const hider = components.get(OBC.Hider);
    const fragments = components.get(OBC.FragmentsManager);
    ids.forEach((id) => {
        const modelFragmentId = modelIds.find((m) => m.modelId === id.modelId);
        hider.set(false, fragments.modelIdToFragmentIdMap({
            [modelFragmentId?.fragmentId!]: new Set([id.expressId]),
        }));
    });
}